import React, { useState } from "react";
import "../styles/Features.css"; // ✅ Importing CSS
import { motion } from "framer-motion"; // ✅ For animations

function Features() {
  // ✅ State for the concussion severity scale
  const [impactForce, setImpactForce] = useState(0);

  // ✅ Function to determine concussion severity based on force
  const getConcussionSeverity = (force) => {
    if (force < 20) return "Minimal Risk";
    if (force < 40) return "Mild Concussion";
    if (force < 60) return "Moderate Concussion";
    if (force < 80) return "Severe Concussion";
    return "Critical Brain Trauma";
  };

  return (
    <div className="features-container">
      {/* ✅ Header Section */}
      <motion.div
        className="features-header"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <h1>AI-Powered Concussion Detection</h1>
        <p>Revolutionizing brain health with real-time, data-driven solutions.</p>
      </motion.div>

      {/* ✅ Feature Grid */}
      <div className="features-grid">
        {/* ✅ First Row */}
        <motion.div className="feature-card" whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
          <h2>AI-Powered Detection</h2>
          <p>Real-time concussion risk analysis using biometric and impact data.</p>
        </motion.div>

        <motion.div className="feature-card" whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
          <h2>Blockchain Security</h2>
          <p>Medical records are encrypted and stored securely on the blockchain.</p>
        </motion.div>

        <motion.div className="feature-card" whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
          <h2>Smart Helmet Integration</h2>
          <p>Seamless compatibility with impact-tracking headgear and wearables.</p>
        </motion.div>

        <motion.div className="feature-card" whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
          <h2>Instant Alerts</h2>
          <p>Real-time notifications sent to coaches, trainers, and medical personnel.</p>
        </motion.div>

        {/* ✅ Second Row */}
        <motion.div className="feature-card centered" whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
          <h2>AI Data Analytics</h2>
          <p>Track concussion trends and risks with advanced AI analytics.</p>
        </motion.div>

        <motion.div className="feature-card centered" whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
          <h2>Mobile App Access</h2>
          <p>Access real-time reports and player health insights on your phone.</p>
        </motion.div>
      </div>

      {/* ✅ Concussion Severity Scale Section */}
      <div className="concussion-scale">
        <h2>Concussion Severity Scale</h2>
        <p>Drag the slider to simulate impact force and see the concussion severity.</p>

        <input
          type="range"
          min="0"
          max="100"
          value={impactForce}
          onChange={(e) => setImpactForce(e.target.value)}
          className="slider"
        />

        <div className="severity-display">
          {/* ✅ Force Impact Force text to be black */}
          <h3 style={{ color: "black", fontWeight: "bold" }}>Impact Force: {impactForce}G</h3>
          <p className={`severity ${getConcussionSeverity(impactForce).replace(/\s+/g, "-").toLowerCase()}`} style={{ color: "black" }}>
            {getConcussionSeverity(impactForce)}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Features;